export default "__VITE_ASSET__C6OSfyF1__"